"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isMongoId = void 0;
const isMongoId = (value) => {
    const objectIdRegex = /^[0-9a-fA-F]{24}$/;
    return typeof value === 'string' && objectIdRegex.test(value);
};
exports.isMongoId = isMongoId;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaXMtbW9uZ28taWQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvdXRpbHMvaXMtbW9uZ28taWQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQU8sTUFBTSxTQUFTLEdBQUcsQ0FBQyxLQUFhLEVBQUUsRUFBRTtJQUN6QyxNQUFNLGFBQWEsR0FBRyxtQkFBbUIsQ0FBQztJQUMxQyxPQUFPLE9BQU8sS0FBSyxLQUFLLFFBQVEsSUFBSSxhQUFhLENBQUMsSUFBSSxDQUFDLEtBQUssQ0FBQyxDQUFDO0FBQ2hFLENBQUMsQ0FBQztBQUhXLFFBQUEsU0FBUyxhQUdwQiJ9